import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { firestorePlugin } from "vuefire";
Vue.use(firestorePlugin);
import { firebaseConfig } from "@/firebaseConfig";
let _fireApp = firebase.initializeApp(firebaseConfig);
_fireApp.auth().languageCode = "ko";
export const db = _fireApp.firestore();
